export const DOCS_BASE = '/documentation';

export type DocItem = { slug: string; title: string };
export type DocGroup = { group: string; items: DocItem[] };

export const DOCS_NAV: DocGroup[] = [
  {
    group: 'Getting started',
    items: [
      { slug: 'platform', title: 'The StyTrix platform' },
      { slug: 'introduction', title: 'For AI agents' },
    ],
  },
  {
    group: 'Canvas tools',
    items: [
      { slug: 'canvas-tools', title: 'Using the canvas' },
      { slug: 'generation-tools', title: 'Generation tools' },
      { slug: 'model-tools', title: 'Model tools' },
      { slug: 'resource-libraries', title: 'Resource libraries' },
    ],
  },
  {
    group: 'Connect',
    items: [
      { slug: 'quickstart', title: 'Quick start' },
      { slug: 'connect', title: 'MCP connector' },
      { slug: 'skill', title: 'StyTrix skill' },
      { slug: 'cli', title: 'StyTrix CLI' },
    ],
  },
  {
    group: 'Reference',
    items: [
      { slug: 'tools', title: 'Tools' },
      { slug: 'prompts', title: 'Writing prompts' },
      { slug: 'faq', title: 'FAQ' },
    ],
  },
];

export const DOCS_FLAT: DocItem[] = DOCS_NAV.flatMap((g) => g.items);

export function docHref(slug: string) {
  return `${DOCS_BASE}/${slug}`;
}

export function prevNext(slug: string): { prev?: DocItem; next?: DocItem } {
  const i = DOCS_FLAT.findIndex((d) => d.slug === slug);
  return {
    prev: i > 0 ? DOCS_FLAT[i - 1] : undefined,
    next: i >= 0 && i < DOCS_FLAT.length - 1 ? DOCS_FLAT[i + 1] : undefined,
  };
}
